// @flow

import { observer } from "mobx-react";
import React from "react";

import VideoStore from "app/stores/VideoStore";
import TimelineItemStore from "app/stores/TimelineItemStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";

import VideoProgressRange from "app/components/VideoProgressRange/VideoProgressRange";

@observer
export default class VideoProgressRangeContainer extends React.Component<
    *
> {
    render() {
        if (!TimelineItemStore.wizard || !TimelineItemStore.selectedItem)
            return null;

        const item = TimelineItemStore.selectedItem;

        return (
            <VideoProgressRange
                duration={VideoStore.video.duration}
                progress={VideoPlayerStore.progress}
                onSeek={VideoPlayerStore.seekTo}
                start={item.start_time}
                stop={item.stop_time}
                startBoundary={TimelineItemStore.wizardStartBoundary}
                stopBoundary={TimelineItemStore.wizardStopBoundary}
                onDrag={TimelineItemStore.drag}
                onDragStop={TimelineItemStore.dragStop}
                onUpdateStartTime={TimelineItemStore.updateStartTime}
                onUpdateStopTime={TimelineItemStore.updateStopTime}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoProgressRangeContainer.js